'use strict';

import {Button} from "../Button";
import {previewClickHandler} from "../../../cards/unitCards/unitCardFunctions";
import {cardsData} from "../../../../settings";

export class ExploreButton extends Button {
  constructor(location) {
    super('Explore');
    this
      .addClass('explore-button')
      .event('click', previewClickHandler);

    if (cardsData.cardMode.isAmenities) {
      this.remove();
    } else if (location === 'cylinder-control-panel') {
      this
        .addClass('cylinder-control-panel__button', 'search__round-button', 'hidden')
        .addAttribute('data-type', 'explore')
        .addTextClass('cylinder-control-panel__button-text', 'menu-icon');
    } else if (location === 'unit-card' && window.innerHeight >= 360 /*&& UnitCardClass.findCard()?.status === 'Available'*/) {
      this.addClass('customer-contact-now-btn', 'button');
    } else if (location === 'search-item') {
      this
        .addClass('search-item__explore-button', 'button');
    }else {
      this.remove();
    }
  }

  static hide(place) {
    if (place === 'unit-card') {
      const button = document.querySelector('.explore-button.customer-contact-now-btn');
      if (button)
        button.classList.add('hidden');
    }
  }

  static show(place) {
    if (place === 'unit-card') {
      const button = document.querySelector('.explore-button.customer-contact-now-btn');
      button?.classList.remove('hidden');
    }
  }
}